import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL //'https://ttelapi.aoinnovations.org'
});

instance.interceptors.request.use(  
    config => {
        const token = sessionStorage.getItem('participant_token');

        config.headers['Content-Type'] = 'application/json';

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export default instance;